{appStore} = require 'stores'

GlobalClick =
  componentWillMount: ->
    appStore.actions.addGlobalClick @globalClick
  componentWillUnmount: ->
    appStore.actions.removeGlobalClick @globalClick

module.exports = GlobalClick
